/**
 * Developer API — manage API keys and subscriptions (`/api/v1/developer/*`).
 */
import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000'

const devAxios = axios.create({
  baseURL: `${API_BASE_URL}/api/v1/developer`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 60_000,
})

devAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('dizeeToken')
  if (token) {
    try {
      const parsed = JSON.parse(token)
      config.headers.Authorization = `Bearer ${parsed}`
    } catch {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

function unwrap(body: any): any {
  return body?.data ?? body
}

export async function listDeveloperKeys() {
  const { data: body } = await devAxios.get('keys')
  return unwrap(body) as { keys: Array<Record<string, unknown>> }
}

export async function createDeveloperKey(name: string) {
  const { data: body } = await devAxios.post('keys', { name })
  return unwrap(body) as { key: string; apiKey: Record<string, unknown> }
}

export async function revokeDeveloperKey(id: string) {
  const { data: body } = await devAxios.delete(`keys/${id}`)
  return unwrap(body)
}

export async function getDeveloperUsage() {
  const { data: body } = await devAxios.get('usage')
  return unwrap(body)
}

export async function getDeveloperSubscription() {
  const { data: body } = await devAxios.get('subscription')
  return unwrap(body) as { highestTier: string; keys: number }
}

export async function subscribeDeveloperApi(tier: 'pro' | 'enterprise', billing: 'monthly' | 'yearly' = 'monthly') {
  const { data: body } = await devAxios.post('subscribe', { tier, billing })
  return unwrap(body) as { url: string }
}

export function publicDocsUrl(): string {
  return `${API_BASE_URL}/public/v1/docs`
}

export function publicOpenApiUrl(): string {
  return `${API_BASE_URL}/public/v1/openapi.json`
}
